import * as LDClient from 'launchdarkly-js-client-sdk';

let client;

const clientSideId = import.meta.env.VITE_LAUNCH_DARKLY_ID;
const context = {
	kind: 'user',
	key: 'schedules-components',
	name: 'Schedules'
};

client = LDClient.initialize(clientSideId, context);

export const ldClient = client;
export const keys = {
	captchaForCourts: 'captcha-for-courts',
	kidsCampCancellation: 'kids-camp-cancellation'
};
